import '@/styles/globals.css'

import type { FC, ReactNode } from 'react'
import type { AppProps } from 'next/app'

import Head from 'next/head'
import { IBM_Plex_Sans, JetBrains_Mono, Space_Grotesk } from 'next/font/google'

const sans = IBM_Plex_Sans({
    subsets: ['latin'],
    weight: ['400', '500', '600', '700']
})

const mono = JetBrains_Mono({
    subsets: ['latin']
})

const heading = Space_Grotesk({
    subsets: ['latin']
})

const fontVariables = `:root{--font-app-sans:${sans.style.fontFamily};--font-app-mono:${mono.style.fontFamily};--font-app-heading:${heading.style.fontFamily}}`

const App: FC<AppProps> = ({ Component, pageProps }): ReactNode => {
    return (
        <div className='h-full font-sans'>
            <Head>
                <style dangerouslySetInnerHTML={{ __html: fontVariables }} />
            </Head>

            <Component {...pageProps} />
        </div>
    )
}

export default App
